import React from 'react';

import InternationalizationStore from '../../../store/internationalization-store.js'
import {Button ,  ProgressBar} from 'react-bootstrap';
import Certificate from '../../../classes/certificate.js';
import jsPDF from 'jspdf';

class FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <span>{InternationalizationStore.get(this.props.id , this.props.defaultMessage)}</span>
    }
}

class Component extends React.Component {
    constructor(props) {
        super();
        this.props = props
        this.state = {
            students:this.props.data.students || [],
            fetched:[],
            generated:0,
            certificates:[]
        }
    }

    generateCertificate(index , students){

        if(index >= students.length)
        {
            this.setState({
                stage:'generated'
            })

            return;
        }


        var student = students[index];

        var textures = [
            {texture:'./img/achivement/1.png' , position:{x:1529, y:158}},
            {texture:'./img/achivement/3.png' , position:{x:1123, y:1898}},
            {texture:'./img/achivement/4.png' , position:{x:1609, y:1898}},
            {texture:'./img/achivement/5.png' , position:{x:2093, y:1898}},
            {texture:'./img/achivement/6.png' , position:{x:723, y:1606}},
            {texture:'./img/achivement/7.png' , position:{x:1902, y:1636}},
            {texture:'./img/achivement/8.png' , position:{x:694, y:1288}},
            {texture:'./img/achivement/9.png' , position:{x:1902, y:1299}},
            {texture:'./img/achivement/10.png' , position:{x:0, y:0}},
        ];

        var text = [
            {text:'Languagenut Secondary Demo School' , position:{x:1343 , y:454} , style:{fontSize:56} , isCentered:true , centerOffset:0 , isCapitalized:true},
            // {text:'01/01/2020 to 31/12/2020' , position:{x:1343 , y:506} , style:{fontSize:56} , isCentered:true , isCapitalized:false},
            {text:'ACHIVEMENT CEERTICATE' , position:{x:1343 , y:595} , style:{fontSize:101  ,  fontWeight: 'bold'} , centerOffset:0 , isCentered:true , isCapitalized:true},
            {text:'01/01/2020 to 31/12/2020' , position:{x:1343 , y:769} , style:{fontSize:56  } , isCentered:true , centerOffset:0 , isCapitalized:false},
            {text:student.label , position:{x:1343 , y:918} , style:{fontSize:101  ,  fontWeight: 'bold'} , centerOffset:0 , isCentered:true , isCapitalized:true},
            {text:'School Rank:1' , position:{x:1343 , y:1070} , style:{fontSize:56  ,  fontWeight: 'bold'} ,centerOffset:0 ,  isCentered:true , isCapitalized:false},
            {text:'Points:10000000000' , position:{x:1343 , y:1160} , style:{fontSize:56  ,  fontWeight: 'bold'} ,centerOffset:0 ,  isCentered:true , isCapitalized:false},

            {text:'Vocabulary Learnt' , position:{x:980 , y:1357} , style:{fontSize:56 , fontWeight: 'bold'} , centerOffset:0 , isCentered:false , isCapitalized:false},
            {text:'Sentences Learnt' , position:{x:2186 , y:1357} , style:{fontSize:56 , fontWeight: 'bold'} ,  centerOffset:0 , isCentered:false , isCapitalized:false},
            {text:'Grammar & Verb Learnt' , position:{x:980 , y:1656} , style:{fontSize:56 , fontWeight: 'bold'} , centerOffset:0 , isCentered:false , isCapitalized:false},
            {text:'Exam Skills Learnt' , position:{x:2186 , y:1656} , style:{fontSize:56 , fontWeight: 'bold'} , centerOffset:0 , isCentered:false , isCapitalized:false},
            {text:'999999999999' , position:{x:980 , y:1429} , style:{fontSize:101 , } , isCentered:false , centerOffset:0 , isCapitalized:false},
            {text:'999999999999' , position:{x:2186 , y:1429} , style:{fontSize:101 , } , isCentered:false , centerOffset:0 , isCapitalized:false},
            {text:'999999999999' , position:{x:980 , y:1728} , style:{fontSize:101 , } , isCentered:false , centerOffset:0 , isCapitalized:false},
            {text:'999999999999' , position:{x:2186 , y:1728} , style:{fontSize:101 , } , isCentered:false , centerOffset:0 , isCapitalized:false},
            {text:'Gold' , position:{x:2186 , y:2170} , style:{fontSize:56 , fontWeight: 'bold' } , isCentered:true , centerOffset:-500 , isCapitalized:false},
            {text:'Silver' , position:{x:2186 , y:2170} , style:{fontSize:56 , fontWeight: 'bold' } , isCentered:true , centerOffset:-10 , isCapitalized:false},
            {text:'Bronze' , position:{x:2186 , y:2170} , style:{fontSize:56 , fontWeight: 'bold' } , isCentered:true , centerOffset:480 , isCapitalized:false},
            {text:'999999' , position:{x:2186 , y:2240} , style:{fontSize:101 , } , isCentered:true , centerOffset:-500 , isCapitalized:false},
            {text:'999999' , position:{x:2186 , y:2240} , style:{fontSize:101 , } , isCentered:true , centerOffset:-10 , isCapitalized:false},
            {text:'999999' , position:{x:2186 , y:2240} , style:{fontSize:101 , } , isCentered:true , centerOffset:480 , isCapitalized:false},

        ]

        var cert = new Certificate(textures , text);

        cert.image().then(function(image){

            var certificates = this.state.certificates
                certificates.push(image)
              /*  this.setState({
                    generated : this.state.generated + 1,
                    certificates:certificates
                })*/

            setTimeout(function(){
                this.generateCertificate(++index, students)
            }.bind(this), 100)

        }.bind(this));

    }

    componentDidMount(){
        this.generateCertificate(0 , this.state.students);
    }

    getData(index){

        if(this.state.fetched >= this.state.student.length)
        {
            this.generateCertificate();
            return;
        }

    }

    getProgress(){
        return ((this.state.fetched.length + this.state.generated)/(this.state.students.length*2))*100;
    }

    getState()
    {

    }

    download(){
        var doc = new jsPDF('landscape');

        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();


        for(var i = 0 ; i < this.state.certificates.length; i ++)
        {
            var imgData = this.state.certificates[i].src

            doc.addImage(imgData, 'JPEG', 0, 0, width, height);

            doc.addPage();
        }

        doc.save('progress_certificate.pdf');
    }

    render(){

        if(this.state.stage == 'generated')
        {
            return <center><Button onClick={this.download.bind(this)}>Download Certificates</Button></center>
        }

        return <div>

            <ProgressBar animated now={this.getProgress()} />
            <br/>
            <center><p>Generating Certificates ..... </p></center>
        </div>
    }
}

export default {
    name: <FormattedMessage id={'0'} defaultMessage={'Generate Certificate'} />,
    title: null,
    onSubmit: function (done) {
        
        if(!this.props.data.selectedLanguage){
            return done(new Error(InternationalizationStore.get('ui-902' ,'Please Select A Language' )));
        } else {
            return done()
        }
    },
    value: null,
    component: Component
}